import { BrandAssetType } from '@/apis/core';

export enum Tab {
  Image = 'image',
  Link = 'link',
}

export const MODAL_TITLE = {
  [BrandAssetType.Logo]: 'Brand Logo Upload',
  [BrandAssetType.Banner]: 'Brand Banner Upload',
};

export const ASSET_DIMENSIONS = {
  [BrandAssetType.Logo]: { width: 224, height: 224 },
  [BrandAssetType.Banner]: { width: 1440, height: 448 },
};

export const FILE_SIZE_LIMIT = {
  [BrandAssetType.Logo]: 50,
  [BrandAssetType.Banner]: 200,
};

export const ASSET_THUMBNAIL_WIDTH = {
  [BrandAssetType.Logo]: 65,
  [BrandAssetType.Banner]: 187,
};
